import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider } from './chunk-J2FXRRBJ.js';
import { __spreadValues, __objRest } from './chunk-2FEJBM4N.js';
import React3 from 'react';
import { ResponsiveContainer, AreaChart as AreaChart$1, CartesianGrid, Area, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ReferenceArea, Customized, BarChart as BarChart$1, Bar, Cell, ComposedChart as ComposedChart$1, Line, LineChart as LineChart$1, PieChart as PieChart$1, Pie, ScatterChart as ScatterChart$1, Scatter } from 'recharts';

var AreaChart = ({
  data,
  areas,
  xAxis = [],
  yAxis = [],
  extraSvgElements = [],
  options = {},
  configs = {},
  width = "100%",
  height = 400
}) => {
  var _a, _b;
  const areaArray = React3.useMemo(() => {
    if (!areas) return [];
    const arr = Array.isArray(areas) ? [...areas] : [areas];
    return arr.filter(Boolean);
  }, [areas]);
  const xAxisArray = React3.useMemo(() => {
    return Array.isArray(xAxis) ? [...xAxis] : [xAxis];
  }, [xAxis]);
  const yAxisArray = React3.useMemo(() => {
    return Array.isArray(yAxis) ? [...yAxis] : [yAxis];
  }, [yAxis]);
  return /* @__PURE__ */ React3.createElement(ErrorBoundary_default, { componentName: "AreaChart" }, /* @__PURE__ */ React3.createElement(ThemeProvider, null, /* @__PURE__ */ React3.createElement(ResponsiveContainer, { width, height }, /* @__PURE__ */ React3.createElement(
    AreaChart$1,
    __spreadValues({
      data,
      margin: { right: 40 },
      style: { fontFamily: "Sora" }
    }, configs == null ? void 0 : configs.areaChartConfig),
    (options == null ? void 0 : options.cartesianGrid) && /* @ts-ignore */
    /* @__PURE__ */ React3.createElement(
      CartesianGrid,
      __spreadValues({
        strokeDasharray: "3 3"
      }, configs == null ? void 0 : configs.cartesianGridConfig)
    ),
    areaArray.map((areaProps, index) => {
      const _a2 = areaProps, { ref } = _a2, area = __objRest(_a2, ["ref"]);
      return (
        /* @ts-ignore */
        /* @__PURE__ */ React3.createElement(Area, __spreadValues({ key: index + "area", stackId: "1", isAnimationActive: true }, area))
      );
    }),
    extraSvgElements.map((element) => element),
    xAxisArray.length > 0 ? xAxisArray.map((xAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(XAxis, __spreadValues({ key: index + "xaxis" }, xAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(XAxis, null)
    ),
    yAxisArray.length > 0 ? yAxisArray.map((yAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(YAxis, __spreadValues({ key: index + "yaxis" }, yAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(YAxis, null)
    ),
    (options == null ? void 0 : options.tooltip) && /* @__PURE__ */ React3.createElement(
      Tooltip,
      __spreadValues({
        cursor: { stroke: "#666", strokeWidth: 1, strokeOpacity: 1 }
      }, configs == null ? void 0 : configs.tooltipConfig)
    ),
    (options == null ? void 0 : options.legend) && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Legend, __spreadValues({}, configs == null ? void 0 : configs.legendConfig)),
    (options == null ? void 0 : options.referenceLines) && ((_a = configs.referenceLinesConfig) == null ? void 0 : _a.map((referenceLineProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceLine,
        __spreadValues({
          key: index,
          stroke: "#000",
          ifOverflow: "extendDomain"
        }, referenceLineProps)
      )
    ))),
    (options == null ? void 0 : options.referenceAreas) && ((_b = configs.referenceAreasConfig) == null ? void 0 : _b.map((referenceAreaProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceArea,
        __spreadValues({
          key: index,
          fill: "#196F82",
          fillOpacity: 0.5
        }, referenceAreaProps)
      )
    ))),
    (configs == null ? void 0 : configs.customizedComponent) && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Customized, { component: configs.customizedComponent })
  ))));
};
var AreaChart_default = AreaChart;
var BarChart = ({
  data,
  bars,
  xAxis = [],
  yAxis = [],
  cells = [],
  extraSvgElements = [],
  options = {},
  configs = {},
  width = "100%",
  height = 400
}) => {
  var _a, _b;
  const barArray = React3.useMemo(() => {
    if (!bars) return [];
    const arr = Array.isArray(bars) ? [...bars] : [bars];
    return arr.filter(Boolean);
  }, [bars]);
  const xAxisArray = React3.useMemo(() => {
    return Array.isArray(xAxis) ? xAxis : [xAxis];
  }, [xAxis]);
  const yAxisArray = React3.useMemo(() => {
    return Array.isArray(yAxis) ? yAxis : [yAxis];
  }, [yAxis]);
  return /* @__PURE__ */ React3.createElement(ErrorBoundary_default, { componentName: "BarChart" }, /* @__PURE__ */ React3.createElement(ThemeProvider, null, /* @__PURE__ */ React3.createElement(ResponsiveContainer, { width, height }, /* @__PURE__ */ React3.createElement(
    BarChart$1,
    __spreadValues({
      data,
      margin: { right: 40 },
      style: { fontFamily: "Sora" }
    }, configs == null ? void 0 : configs.barChartConfig),
    (options == null ? void 0 : options.cartesianGrid) && /* @ts-ignore */
    /* @__PURE__ */ React3.createElement(
      CartesianGrid,
      __spreadValues({
        strokeDasharray: "3 3"
      }, configs == null ? void 0 : configs.cartesianGridConfig)
    ),
    barArray.map((barProps, index) => {
      const _a2 = barProps, { ref } = _a2, bar = __objRest(_a2, ["ref"]);
      return (
        /* @ts-ignore */
        /* @__PURE__ */ React3.createElement(Bar, __spreadValues({ key: index + "bar", isAnimationActive: true }, bar), cells && cells.map((cell, index2) => (
          // @ts-ignore - recharts React 18 compatibility
          /* @__PURE__ */ React3.createElement(Cell, __spreadValues({ key: `cell-${index2}` }, cell))
        )))
      );
    }),
    extraSvgElements.map((element) => element),
    xAxisArray.length > 0 ? xAxisArray.map((xAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(XAxis, __spreadValues({ key: index + "xaxis" }, xAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(XAxis, null)
    ),
    yAxisArray.length > 0 ? yAxisArray.map((yAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(YAxis, __spreadValues({ key: index + "yaxis" }, yAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(YAxis, null)
    ),
    (options == null ? void 0 : options.tooltip) && /* @__PURE__ */ React3.createElement(
      Tooltip,
      __spreadValues({
        cursor: { fill: "rgba(0, 0, 0, 0.1)" }
      }, configs == null ? void 0 : configs.tooltipConfig)
    ),
    options.legend && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Legend, __spreadValues({}, configs == null ? void 0 : configs.legendConfig)),
    (options == null ? void 0 : options.referenceLines) && ((_a = configs.referenceLinesConfig) == null ? void 0 : _a.map((referenceLineProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceLine,
        __spreadValues({
          key: index,
          stroke: "#000"
        }, referenceLineProps)
      )
    ))),
    (options == null ? void 0 : options.referenceAreas) && ((_b = configs.referenceAreasConfig) == null ? void 0 : _b.map((referenceAreaProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceArea,
        __spreadValues({
          key: index,
          fill: "#196F82",
          fillOpacity: 0.5
        }, referenceAreaProps)
      )
    )))
  ))));
};
var BarChart_default = BarChart;
var ComposedChart = ({
  data,
  bars,
  areas,
  lines,
  xAxis = [],
  yAxis = [],
  cells = [],
  extraSvgElements = [],
  options = {},
  configs = {},
  width = "100%",
  height = 400
}) => {
  var _a, _b;
  const barArray = React3.useMemo(() => {
    if (!bars) return [];
    const arr = Array.isArray(bars) ? [...bars] : [bars];
    return arr.filter(Boolean);
  }, [bars]);
  const areaArray = React3.useMemo(() => {
    if (!areas) return [];
    const arr = Array.isArray(areas) ? [...areas] : [areas];
    return arr.filter(Boolean);
  }, [areas]);
  const lineArray = React3.useMemo(() => {
    if (!lines) return [];
    const arr = Array.isArray(lines) ? [...lines] : [lines];
    return arr.filter(Boolean);
  }, [lines]);
  const xAxisArray = React3.useMemo(() => {
    return Array.isArray(xAxis) ? xAxis : [xAxis];
  }, [xAxis]);
  const yAxisArray = React3.useMemo(() => {
    return Array.isArray(yAxis) ? yAxis : [yAxis];
  }, [yAxis]);
  return /* @__PURE__ */ React3.createElement(ErrorBoundary_default, { componentName: "ComposedChart" }, /* @__PURE__ */ React3.createElement(ThemeProvider, null, /* @__PURE__ */ React3.createElement(ResponsiveContainer, { width, height }, /* @__PURE__ */ React3.createElement(
    ComposedChart$1,
    __spreadValues({
      data,
      margin: { right: 40 },
      style: { fontFamily: "Sora" }
    }, configs == null ? void 0 : configs.composedChartConfig),
    (options == null ? void 0 : options.cartesianGrid) && /* @ts-ignore */
    /* @__PURE__ */ React3.createElement(
      CartesianGrid,
      __spreadValues({
        strokeDasharray: "3 3"
      }, configs == null ? void 0 : configs.cartesianGridConfig)
    ),
    barArray.map((barProps, index) => {
      const _a2 = barProps, { ref } = _a2, bar = __objRest(_a2, ["ref"]);
      return (
        /* @ts-ignore */
        /* @__PURE__ */ React3.createElement(Bar, __spreadValues({ key: index + "bar", isAnimationActive: true }, bar), cells && cells.map((cell, index2) => (
          // @ts-ignore - recharts React 18 compatibility
          /* @__PURE__ */ React3.createElement(Cell, __spreadValues({ key: `cell-${index2}` }, cell))
        )))
      );
    }),
    areaArray.map((areaProps, index) => {
      const _a2 = areaProps, { ref } = _a2, area = __objRest(_a2, ["ref"]);
      return (
        /* @ts-ignore */
        /* @__PURE__ */ React3.createElement(Area, __spreadValues({ key: index + "area", stackId: "1", isAnimationActive: true }, area))
      );
    }),
    lineArray.map((lineProps, index) => {
      const _a2 = lineProps, { ref } = _a2, line = __objRest(_a2, ["ref"]);
      return (
        // @ts-ignore
        /* @__PURE__ */ React3.createElement(Line, __spreadValues({ key: index + "line", isAnimationActive: true }, line))
      );
    }),
    extraSvgElements.map((element) => element),
    xAxisArray.length > 0 ? xAxisArray.map((xAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(XAxis, __spreadValues({ key: index + "xaxis" }, xAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(XAxis, null)
    ),
    yAxisArray.length > 0 ? yAxisArray.map((yAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(YAxis, __spreadValues({ key: index + "yaxis" }, yAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(YAxis, null)
    ),
    (options == null ? void 0 : options.tooltip) && /* @__PURE__ */ React3.createElement(
      Tooltip,
      __spreadValues({
        cursor: { stroke: "#666", strokeWidth: 1, strokeOpacity: 1 }
      }, configs == null ? void 0 : configs.tooltipConfig)
    ),
    options.legend && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Legend, __spreadValues({}, configs == null ? void 0 : configs.legendConfig)),
    (options == null ? void 0 : options.referenceLines) && ((_a = configs.referenceLinesConfig) == null ? void 0 : _a.map((referenceLineProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceLine,
        __spreadValues({
          key: index,
          stroke: "#000"
        }, referenceLineProps)
      )
    ))),
    (options == null ? void 0 : options.referenceAreas) && ((_b = configs.referenceAreasConfig) == null ? void 0 : _b.map((referenceAreaProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceArea,
        __spreadValues({
          key: index,
          fill: "#196F82",
          fillOpacity: 0.5
        }, referenceAreaProps)
      )
    )))
  ))));
};
var ComposedChart_default = ComposedChart;
var LineChart = ({
  data,
  lines,
  xAxis = [],
  yAxis = [],
  extraSvgElements = [],
  options = {},
  configs = {},
  width = "100%",
  height = 400
}) => {
  var _a, _b;
  const lineArray = React3.useMemo(() => {
    if (!lines) return [];
    const arr = Array.isArray(lines) ? [...lines] : [lines];
    return arr.filter(Boolean);
  }, [lines]);
  const xAxisArray = React3.useMemo(() => {
    return Array.isArray(xAxis) ? xAxis : [xAxis];
  }, [xAxis]);
  const yAxisArray = React3.useMemo(() => {
    return Array.isArray(yAxis) ? yAxis : [yAxis];
  }, [yAxis]);
  return /* @__PURE__ */ React3.createElement(ErrorBoundary_default, { componentName: "LineChart" }, /* @__PURE__ */ React3.createElement(ThemeProvider, null, /* @__PURE__ */ React3.createElement(ResponsiveContainer, { width, height }, /* @__PURE__ */ React3.createElement(
    LineChart$1,
    __spreadValues({
      data,
      margin: { right: 40 },
      style: { fontFamily: "Sora" }
    }, configs == null ? void 0 : configs.lineChartConfig),
    (options == null ? void 0 : options.cartesianGrid) && /* @ts-ignore */
    /* @__PURE__ */ React3.createElement(
      CartesianGrid,
      __spreadValues({
        strokeDasharray: "3 3"
      }, configs == null ? void 0 : configs.cartesianGridConfig)
    ),
    lineArray.map((lineProps, index) => {
      const _a2 = lineProps, { ref } = _a2, line = __objRest(_a2, ["ref"]);
      return (
        // @ts-ignore
        /* @__PURE__ */ React3.createElement(Line, __spreadValues({ key: index + "line", isAnimationActive: true }, line))
      );
    }),
    extraSvgElements.map((element) => element),
    xAxisArray.length > 0 ? xAxisArray.map((xAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(XAxis, __spreadValues({ key: index + "xaxis" }, xAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(XAxis, null)
    ),
    yAxisArray.length > 0 ? yAxisArray.map((yAxis2, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(YAxis, __spreadValues({ key: index + "yaxis" }, yAxis2))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(YAxis, null)
    ),
    (options == null ? void 0 : options.tooltip) && /* @__PURE__ */ React3.createElement(
      Tooltip,
      __spreadValues({
        cursor: { stroke: "#666", strokeWidth: 1, strokeOpacity: 1 }
      }, configs == null ? void 0 : configs.tooltipConfig)
    ),
    (options == null ? void 0 : options.legend) && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Legend, __spreadValues({}, configs == null ? void 0 : configs.legendConfig)),
    (options == null ? void 0 : options.referenceLines) && ((_a = configs.referenceLinesConfig) == null ? void 0 : _a.map((referenceLineProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceLine,
        __spreadValues({
          key: index,
          stroke: "#000"
        }, referenceLineProps)
      )
    ))),
    (options == null ? void 0 : options.referenceAreas) && ((_b = configs.referenceAreasConfig) == null ? void 0 : _b.map((referenceAreaProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceArea,
        __spreadValues({
          key: index,
          fill: "#196F82",
          fillOpacity: 0.5
        }, referenceAreaProps)
      )
    )))
  ))));
};
var LineChart_default = LineChart;
var PieChart = ({
  pies,
  cells = [],
  extraSvgElements = [],
  options = {},
  configs = {}
}) => {
  const pieArray = React3.useMemo(() => {
    if (!pies) return [];
    const arr = Array.isArray(pies) ? [...pies] : [pies];
    return arr.filter(Boolean);
  }, [pies]);
  return /* @__PURE__ */ React3.createElement(ErrorBoundary_default, { componentName: "PieChart" }, /* @__PURE__ */ React3.createElement(ThemeProvider, null, /* @__PURE__ */ React3.createElement(
    PieChart$1,
    __spreadValues({
      width: 500,
      height: 400,
      style: { fontFamily: "Sora" }
    }, configs == null ? void 0 : configs.pieChartConfig),
    pieArray.map((pieProps, index) => {
      const _a = pieProps, { ref } = _a, pie = __objRest(_a, ["ref"]);
      return (
        // @ts-ignore
        /* @__PURE__ */ React3.createElement(Pie, __spreadValues({ key: index }, pie), cells && cells.map((cell, index2) => (
          // @ts-ignore - recharts React 18 compatibility
          /* @__PURE__ */ React3.createElement(Cell, __spreadValues({ key: `cell-${index2}` }, cell))
        )))
      );
    }),
    extraSvgElements.map((element) => element),
    (options == null ? void 0 : options.tooltip) && /* @__PURE__ */ React3.createElement(Tooltip, __spreadValues({}, configs == null ? void 0 : configs.tooltipConfig)),
    (options == null ? void 0 : options.legend) && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Legend, __spreadValues({}, configs == null ? void 0 : configs.legendConfig))
  )));
};
var PieChart_default = PieChart;
var ScatterChart = ({
  data,
  scatters,
  xAxis = [],
  yAxis = [],
  extraSvgElements = [],
  options = {},
  configs = {},
  width = "100%",
  height = 400
}) => {
  var _a, _b;
  const scattersArray = React3.useMemo(() => {
    if (!scatters) return [];
    const arr = Array.isArray(scatters) ? [...scatters] : [scatters];
    return arr.filter(Boolean);
  }, [scatters]);
  const xAxisArray = React3.useMemo(() => {
    return Array.isArray(xAxis) ? xAxis : [xAxis];
  }, [xAxis]);
  const yAxisArray = React3.useMemo(() => {
    return Array.isArray(yAxis) ? yAxis : [yAxis];
  }, [yAxis]);
  return /* @__PURE__ */ React3.createElement(ErrorBoundary_default, { componentName: "ScatterChart" }, /* @__PURE__ */ React3.createElement(ThemeProvider, null, /* @__PURE__ */ React3.createElement(ResponsiveContainer, { width, height }, /* @__PURE__ */ React3.createElement(
    ScatterChart$1,
    __spreadValues({
      data,
      margin: { right: 40 },
      style: { fontFamily: "Sora" }
    }, configs == null ? void 0 : configs.scatterChartConfig),
    (options == null ? void 0 : options.cartesianGrid) && /* @ts-ignore */
    /* @__PURE__ */ React3.createElement(
      CartesianGrid,
      __spreadValues({
        strokeDasharray: "3 3",
        stroke: "#ccc",
        strokeOpacity: 1
      }, configs == null ? void 0 : configs.cartesianGridConfig)
    ),
    xAxisArray.length > 0 ? xAxisArray.map((xAxisProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(XAxis, __spreadValues({ key: index + "xaxis" }, xAxisProps))
    )) : (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(XAxis, { type: "number" })
    ),
    yAxisArray.length > 0 ? yAxisArray.map((yAxisProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(YAxis, __spreadValues({ key: index + "yaxis" }, yAxisProps))
    )) : (
      // @ts-ignore - recharts React 18 compatibility
      /* @__PURE__ */ React3.createElement(YAxis, { type: "number" })
    ),
    (options == null ? void 0 : options.referenceAreas) && ((_a = configs.referenceAreasConfig) == null ? void 0 : _a.map((referenceAreaProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceArea,
        __spreadValues({
          key: index,
          fill: "#196F82",
          fillOpacity: 0.5
        }, referenceAreaProps)
      )
    ))),
    scattersArray.map((scatterProps, index) => {
      const _a2 = scatterProps, { ref } = _a2, scatter = __objRest(_a2, ["ref"]);
      return (
        // @ts-ignore - In Recharts 3.x, ScatterChart requires data on each Scatter component
        /* @__PURE__ */ React3.createElement(Scatter, __spreadValues({ key: index + "scatter", data }, scatter))
      );
    }),
    (options == null ? void 0 : options.referenceLines) && ((_b = configs.referenceLinesConfig) == null ? void 0 : _b.map((referenceLineProps, index) => (
      // @ts-ignore
      /* @__PURE__ */ React3.createElement(
        ReferenceLine,
        __spreadValues({
          key: index,
          stroke: "#000",
          strokeWidth: 1,
          strokeOpacity: 1,
          ifOverflow: "extendDomain"
        }, referenceLineProps)
      )
    ))),
    extraSvgElements.map((element) => element),
    (options == null ? void 0 : options.tooltip) && /* @__PURE__ */ React3.createElement(
      Tooltip,
      __spreadValues({
        cursor: { stroke: "#666", strokeWidth: 1, strokeOpacity: 1 }
      }, configs == null ? void 0 : configs.tooltipConfig)
    ),
    (options == null ? void 0 : options.legend) && // @ts-ignore
    /* @__PURE__ */ React3.createElement(Legend, __spreadValues({}, configs == null ? void 0 : configs.legendConfig))
  ))));
};
var ScatterChart_default = ScatterChart;

export { AreaChart_default, BarChart_default, ComposedChart_default, LineChart_default, PieChart_default, ScatterChart_default };
//# sourceMappingURL=chunk-XYDIJYBT.js.map
//# sourceMappingURL=chunk-XYDIJYBT.js.map